<template>
  <div id="noon-form-date-time-picker">
    <vs-row vs-w="12">
      <vs-col
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="center"
        vs-w="12"
      >
        <v-date-picker
          class="inline-block h-full"
          mode="dateTime"
          v-model="dateTime"
          :is24hr="is24hr"
          :masks="masks"
        >
          <template v-slot="{ inputValue, togglePopover }">
            <div class="aisea-text-14-400-gray">{{ form.label }}</div>
            <vs-input
              size="large"
              v-model="inputValue"
              @click="togglePopover"
              :disabled="isUndecided"
              readonly
            />
          </template>
        </v-date-picker>
        <vs-checkbox
          v-model="isUndecided"
          :color="AISEA_COLOR.BLUE"
          class="mt-6 pl-10"
          ><span>未定</span></vs-checkbox
        >
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import moment from "moment-timezone";

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    form: { type: Object, required: true },
    value: { required: false }
  },
  data() {
    return {
      dateTime: new Date(),
      is24hr: this.form.format.includes('H'),
      masks: {
        title: 'YYYY年 MMM',
        inputDateTime: this.form.format.replace("yyyy", "YYYY").replaceAll('d', 'D'),
        inputDateTime24hr: this.form.format.replace("yyyy", "YYYY").replaceAll('d', 'D')
      },
      isUndecided: false,
    }
  },
  watch: {
    dateTime: {
      handler(val) {
        // 時間が設定されていない場合、「未定」にチェックをつける
        this.isUndecided = !val;

        let dateTime = this.setDateTimeFormat(val)
        const payload = {
          id: this.form.id,
          label: dateTime,
          value: dateTime,
          isAlert: false
        };
        this.$emit("setValue", payload)
      },
    },
    isUndecided(val) {
      let payload
      if (val) {
        payload = {
          id: this.form.id,
          label: "",
          value: "",
          isAlert: false
        };
      } else {
        let dateTime = this.setDateTimeFormat(this.dateTime);
        payload = {
          id: this.form.id,
          label: dateTime,
          value: dateTime,
          isAlert: false
        };
      }

      this.$emit("setValue", payload)
    }
  },
  computed: {
    _inputValue() {
      return this.setDateTimeFormat(this.dateTime)
    },
  },
  methods: {
    setDateTimeFormat(val) {
      const format = this.form.format.replace("yyyy", "YYYY").replaceAll('d', 'D')
      return moment(val).format(format);
    },
  },
  mounted() {
    if (this.value) {
      this.dateTime = new Date(this.value);
    } else {
      this.isUndecided = true;
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/vessel-noon-report.scss";

#noon-form-date-time-picker {
  .vs-input--input:focus {
    border: 1px solid $aisea-blue !important;
  }

  .vs-input-primary.isFocus .vs-input--input:focus ~ .icon-inputx {
    color: $aisea-blue !important;
  }
}
</style>
